// eslint-disable-next-line no-restricted-imports
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { useLoggedInAuthContext } from 'common';

import { formatUserName } from '../../components/Users/utils';

export function usePostHogIdentifyEffect() {
  const { user, defaultOrganization } = useLoggedInAuthContext();
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.identify(
      user.id,
      {}, // setting properties here will trigger an event even if the user is already identified. Leave empty.
      {
        /**
         * If this code is used in a patient facing app, DO NOT include PHI or PII, such as email,
         * address, zip code, or health data
         */
        email: user.email,
        defaultOrganizationId: defaultOrganization?.id,
        defaultOrganizationName: defaultOrganization?.name,
        name: formatUserName(user),
      }
    );
  }, [posthog, user, defaultOrganization]);
}
